import React from 'react'
import { Box, Typography } from '@mui/material'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import { RelatedIssues } from '../../issues/RelatedIssues'
import { SourcesTable } from '../../../components/entities/SourcesTable'
import { CompensationLenders } from './CompensationLenders'

function ExternalCommentBlock({ convertible }: { convertible: ConvertibleEntity }) {
    return convertible.externalComment ? (
        <Box sx={{ whiteSpace: 'pre-line', mb: 2 }}>
            <Typography variant='body1'>{convertible.externalComment}</Typography>
        </Box>
    ) : null
}

const ConvertibleOtherInfo = ({ convertible }: { convertible: ConvertibleEntity }) => {
    return (
        <>
            <ExternalCommentBlock convertible={convertible} />
            {convertible.linkedIssues.length > 0 && <RelatedIssues linkedIssues={convertible.linkedIssues} />}
            {convertible.warrants.length > 0 && <CompensationLenders convertible={convertible} />}
            {convertible.sources.length > 0 && (
                <SourcesTable companyId={convertible.companyId} sources={convertible.sources} />
            )}
        </>
    )
}

export default ConvertibleOtherInfo
